import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { Buffer } from 'buffer';

import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import configureStore, { history } from './store';
import App from './App';

import 'antd/dist/antd.min.css';

// Polyfill for Buffer
if (typeof window !== 'undefined') {
  window.Buffer = window.Buffer || Buffer;
}

const store = configureStore();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// opts into an offline-first app
serviceWorkerRegistration.register();
